import { Button, Select, TagsInput, TextInput } from "@mantine/core";
import Container from "../components/common/Container";
import PageHeader from "../components/common/PageHeader";
import { useForm } from "@mantine/form";
import { validateRequired } from "../utils/validations";
import { creationNotification } from "../utils/useNotification";
import { createSkill } from "../api/skillApi";
import { useAuth } from "../context/AuthContext";
import { useRef } from "react";
import PlusIcon from "../components/common/Icons/PlusIcon";

const NewSkill = () => {
  const { refetchSkillSelectData } = useAuth();
  const formRef = useRef<HTMLFormElement>(null);

  const form = useForm<any>({
    initialValues: {
      name: "",
      description: "",
    },
    validate: {
      name: validateRequired,
      description: validateRequired,
    },
  });

  const handleSubmit = async (values: object) => {
    try {
      const { data, response }: any = await createSkill({
        ...values,
      });

      if (data?.success) {
        creationNotification("Yetenek", data.success);
        refetchSkillSelectData();
        form.reset();
        return;
      }

      if (response?.data?.error) {
        alert(response?.data.error);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <Container>
      <PageHeader
        pageTitle="Yeni Yetenek Kaydı"
        isButtoned
        buttonText="Oluştur"
        buttonIcon={<PlusIcon />}
        buttonOnClick={() => formRef.current?.requestSubmit()}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "40px",
        }}
      >
        <form
          ref={formRef}
          style={{
            width: "448px",
            display: "flex",
            flexDirection: "column",
            gap: "24px",
          }}
          onSubmit={form.onSubmit(handleSubmit)}
        >
          <TextInput
            label="Yetenek İsmi"
            placeholder="Yetenek İsmi Giriniz."
            radius={10}
            maxLength={40}
            size="md"
            {...form.getInputProps("name")}
          />
          <TextInput
            label="Yetenek Açıklaması"
            placeholder="Yetenek Açıklaması Giriniz."
            radius={10}
            maxLength={150}
            size="md"
            {...form.getInputProps("description")}
          />
        </form>
      </div>
    </Container>
  );
};

export default NewSkill;
